// eslint-disable-next-line spaced-comment
/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { config } from './app/app.config.browser';
import { initSentry } from './sentry';

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(duration);
dayjs.extend(localizedFormat);

if (environment.production) {
  enableProdMode();
  initSentry();
}

bootstrapApplication(AppComponent, config).catch((err) => console.error(err));
